import { useRevalidator } from 'react-router-dom';
import axiosInstance from '../config/AxiosConfig';
import { useRouteId } from 'react-router/dist/lib/hooks';

const AuthService = () => {
  const login = async (email: string, password: string) => {
    try {
      const request = {
        email: email,
        password: password
      };

      const response = await axiosInstance.post('/v1/legacy/cms/auth/login', request);

      if (!response?.data) {
        throw new Error('Invalid response');
      }

      const user = response.data?.data;
      // const hasAdmin = user?.priviledges?.some(
      //   (p: any) => p.applicationType === "Admin Transmora"
      // );

      // if (!hasAdmin) {
      //   throw new Error("Akses ditolak. Anda tidak memiliki izin Admin Transmora.");
      // }

      return response;

    } catch (error: any) {
      throw error.message || "Login gagal";
    }
  };

  const forgotPasswordSendOtp = async (email: string) => {
    try {
      const request = { email };
      const response = await axiosInstance.post('/v1/legacy/cms/auth/forgot-password/send-otp', request);

      if (!response?.data) {
        throw new Error('Invalid response');
      }
      return response.data;
    } catch (error: any) {
      throw error.message || 'Gagal mengirim OTP';
    }
  };

  const forgotPasswordResendOtp = async (email: string) => {
    try {
      const request = { email };
      const response = await axiosInstance.post('/v1/legacy/cms/auth/forgot-password/resend-otp', request);

      if (!response?.data) {
        throw new Error('Invalid response');
      }
      return response.data;
    } catch (error: any) {
      throw error.message || 'Gagal mengirim ulang OTP';
    }
  };

  const forgotPasswordVerifyOtp = async (email: string, sessionId: string, otp: string) => {
    try {
      const request = { email, sessionId, otp };
      const response = await axiosInstance.post('/v1/legacy/cms/auth/forgot-password/verify-otp', request);

      if (!response?.data) {
        throw new Error('Invalid response');
      }
      return response.data;
    } catch (error: any) {
      throw error.message || 'Verifikasi OTP gagal';
    }
  };

  const forgotPasswordReset = async (sessionId: string, newPassword: string, confirmPassword: string) => {
  try {
    const request = { sessionId, newPassword: newPassword, confirmPassword: confirmPassword };
    const response = await axiosInstance.post('/v1/legacy/cms/auth/forgot-password/reset', request);

    if (!response?.data) {
      throw new Error('Invalid response');
    }
    return response.data;
  } catch (error: any) {
    throw (
      error?.response?.data?.message || 
      error?.message || 
      'Reset password gagal'
    );
  }
};


  const requestForgotPassword = async (email: string) => {
    try {
      const request = {
        email: email
      };
      const response = await axiosInstance.post('/v1/auth/forgot-password/request', request);
      console.log('Forgot Password Response:', response);
      if (!('data' in response) || response.data == null) {
        throw new Error('Invalid response');
      }
      return response;
    } catch (error: any) {
      // console.error('Forgot Password Error:', error.message);
      throw error.message;
    }
  };

  const verifyForgotPassword = async (email: string, sessionId: string, verificationCode: string) => {
    try {
      const request = {
        email: email,
        sessionId: sessionId,
        verificationCode: verificationCode
      };
      const response = await axiosInstance.post('/v1/auth/forgot-password/validate', request);
      console.log('Verify Forgot Password Response:', response);
      if (!('data' in response) || response.data == null) {
        throw new Error('Invalid response');
      }      
      return response;
    } catch (error: any) {
      // console.error('Verify Forgot Password Error:', error.message);
      throw error.message;
    }
  };

  const changeNewPassword = async (email: string, sessionId: string, newPassword: string) => {
    try {
      const request = {
        email: email,
        sessionId: sessionId,
        newPassword: newPassword
      };
      const response = await axiosInstance.post('/v1/auth/forgot-password/change-password', request);
      console.log('Change Password Response:', response);
      if (!('data' in response) || response.data == null) {
        throw new Error('Invalid response');
      }      
      return response;
    } catch (error: any) {
      // console.error('Verify Forgot Password Error:', error.message);
      throw error.message;
    }
  };

  const projectList = async(userId:string, token:string) => {
    try {
      const response = await axiosInstance.get(`/v1/project/list?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  const projectDetail = async (projectId: string, token: string) => {
    try {
      const response = await axiosInstance.get(`/v1/project/detail?projectId=${projectId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const projectLocations = async (projectId: string, token: string, filters: any = []) => {
    try {
      const body = {
        projectId: projectId,
        filters: filters
      };
      const response = await axiosInstance.post(`/v1/dashboard/data/list`, body, {        
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const projectLocationDetail = async (locationId: string, token: string) => {
    try {
      const body: any = {
        dataId: locationId
      };
      const response = await axiosInstance.post(`/v1/dashboard/data/detail`, body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const toggleFavorite = async (dataId: string, toggle:boolean, token: string) => {
    try {
      const body: any = {
        dataId: dataId,
        toggle: toggle
      };
      const response = await axiosInstance.post(`/v1/dashboard/data/toggleFavorite`, body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const downloadReport = async (projectId: string, token: string, filters: any=[]) => {
    try {
      const body = {
        projectId: projectId,
        filters: filters
      };
      const response = await axiosInstance.post(`/v1/dashboard/data/exportExcel`, body, { 
        responseType: "blob",       
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  const updateFcmToken = async (fcmToken: string, token: string) => {
    try {
      const body = {
        fcmToken,
        applicationType: 1
      };
      const response = await axiosInstance.post('/v1/legacy/cms/auth/fcm-token', body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      console.error('Failed to update FCM token:', error);
      throw error?.response?.data?.message || error.message || 'Failed to update FCM token';
    }
  };

  return {
    login,
    updateFcmToken,
    forgotPasswordSendOtp,
    forgotPasswordResendOtp,
    forgotPasswordVerifyOtp,
    forgotPasswordReset, 
    projectList, projectDetail, 
    projectLocations, projectLocationDetail, 
    requestForgotPassword, verifyForgotPassword, 
    changeNewPassword, toggleFavorite, downloadReport
  };
};

export default AuthService;